import { useParams, useLocation } from "react-router-dom";

export const usePath = () => {
  const { location } = useParams();
  const currentLocation = useLocation();
  
  // If we have location from params, use it
  if (location) {
    return location;
  }
  
  // Otherwise, extract from URL pathname (for routes like /retirees)
  const pathSegments = currentLocation.pathname.split("/");
  return pathSegments[1] || "";
};
